import { resolveComponent as n, createElementBlock as t, openBlock as c, createElementVNode as e, createVNode as a, toDisplayString as s } from "vue";
import { _ as d } from "./main-BMmugWNt.js";
const p = {
  name: "SharedContentErrorNode"
};
function i(o, l, _, m, f, u) {
  const r = n("a-icon");
  return c(), t("div", { class: "pb-shared-content-error" }, [
    e("div", null, [
      a(r, {
        class: "shared-content-error-icon",
        icon: "24:warning"
      }),
      e("p", { class: "error-text" }, s(o.$t("builder.content.sharedContentError.notFound")), 1)
    ])
  ]);
}
const $ = /* @__PURE__ */ d(p, [["render", i], ["__scopeId", "data-v-b18e588e"]]);
export {
  $ as default
};
